import { render } from "./CheckMarkSecondaryIcon.vue?vue&type=template&id=b010e8aa"
const script = {}
script.render = render

export default script